
import { Component, Prop, Watch } from 'vue-property-decorator';

import { MetaInfo } from 'vue-meta';
import { ActivitiesApi } from '@/api/ActivitiesApi';
import { ActivityResponse } from '@/interfaces/Activities';
import first from 'lodash/first';
import { isEmptyValue } from '@/config/functions';
import BaseEditablePage from '@/components/BaseEditablePage.vue';

@Component({
   metaInfo(): MetaInfo {
      return {
         // @ts-ignore
         title: this.model?.o_name,
      };
   },
   components: {
      ObjectForm: () => import('./_Form.vue'),
   },
})
export default class View extends BaseEditablePage {
   @Prop({ type: [Number, String], default: 0 }) id!: number | string;

   model: ActivityResponse | null = null;

   o_cost_New: any = {};

   o_cost_Current: any = {};

   mounted() {
      this.getOrder();
   }

   getOrder() {
      if (this.id <= 0) {
         return;
      }

      this.$store.commit('showLoading');
      return ActivitiesApi.get(this.id)
         .then(({ activity, o_cost_Current, o_cost_New }) => {
            this.model = {
               ...activity,
               o_act_color: isEmptyValue(activity['o_act_color']) ? first(this.activities_colors)?.d_code : activity['o_act_color'],
            };
            this.o_cost_Current = o_cost_Current;
            this.o_cost_New = o_cost_New;
         })
         .then(() => {
            this.$store.dispatch('get_all');
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   @Watch('id')
   changeOrderId() {
      this.getOrder();
   }
}
